import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsWMSOverview() {
  return (
    <IntegrationDocTemplate
      title="Warehousing & 3PL Overview"
      category="Warehousing · 3PL"
      status="live"
      summary="Two paths to fulfillment: (1) post an RFQ on our marketplace and let 3PLs bid for your business in hours, not weeks — or (2) bring an existing 3PL relationship and connect via API. We standardize the operational layer: inventory, allocation, pick tickets, manifests, labels, POD, shipment tracking."
      prerequisites={[
        'Either a need to find a 3PL (RFQ marketplace path) or an existing 3PL contract you want to integrate.',
        'Volume estimate (orders/month) to scope correctly — under 1K is "DIY/Amazon MCF" territory, 1-10K is "ShipBob/ShipMonk" tier, 10K+ is "Flexport/ShipHero/multi-warehouse".',
        'Product category — apparel, food, hazmat, oversized require specific 3PL capabilities.',
      ]}
      connectSteps={[
        <>Text us "I need a 3PL for X orders/month, in Y region" — our <code>rfq_agent</code> drafts a formal RFQ.</>,
        <>RFQ posted to matched 3PLs based on capability/region/capacity. Bids arrive in hours.</>,
        <>You compare ranked bids (Cost × Speed × Reputation). Pick one and sign via DocuSign with Stripe escrow.</>,
        <>Operational integration auto-connects: inventory, orders, manifests, POD — all flowing through our adapter.</>,
      ]}
      syncedData={[
        { type: 'Inventory', detail: '3PL → CI inventory levels (real-time webhook or 15-min poll)' },
        { type: 'Allocation', detail: 'CI → 3PL: which orders to fulfill from which warehouse' },
        { type: 'Pick tickets', detail: 'CI → 3PL: per-order pick instructions with priority/expedite flags' },
        { type: 'Manifests', detail: '3PL → CI: daily manifests with ASN data' },
        { type: 'Labels', detail: 'CI ↔ carrier: rate-shop across UPS/FedEx/USPS/DHL via existing fulfillment/carrier_service.py' },
        { type: 'POD (Proof of Delivery)', detail: '3PL → CI: delivery confirmation with signature/photo' },
        { type: 'Shipment tracking', detail: 'Carrier events flow 3PL → CI → consumer via existing wismo_service.py' },
      ]}
      agents={[
        { id: 'rfq_agent', name: 'rfq_agent', role: 'Seller-side: drafts RFQs from chat, ranks bids' },
        { id: 'three_pl_partnership', name: 'three_pl_partnership', role: 'Provider-side: auto-drafts bids on matching RFQs' },
        { id: 'head_supply_chain', name: 'head_supply_chain', role: 'Director coordinating all logistics agents' },
      ]}
      troubleshooting={[
        { question: 'No matching 3PLs for my RFQ', answer: 'Common reasons: unusual capability (hazmat, frozen, oversized), niche region, or volume below 3PL minimums. Try our Amazon MCF integration as a stepping stone.' },
        { question: 'Bids too high', answer: 'Counter-offer through the RFQ thread — agents negotiate on both sides within authorized bounds. Or extend your RFQ deadline to invite more bidders.' },
      ]}
      supportLink="/contact"
    />
  );
}
